// extracted by mini-css-extract-plugin
export default {"badge":"ShuttleStatus_badge__px8iE","iconBox":"ShuttleStatus_iconBox__OuGMe","icon":"ShuttleStatus_icon__JcGOD"};